import {
  User, Film, Camera, Clapperboard, GraduationCap, BookOpen, Globe2,
  Palette, Disc3, Dumbbell, HeartHandshake, Phone, Projector,
} from "lucide-react";
import { SLOTS, MODELS } from "@/content/schemas";

export const HOME_VIEW = { pos: [9.5, 7.2, 9.5], target: [0, 1.3, -0.6] };
export const START_VIEW = { pos: [17, 13, 17], target: [0, 1.3, -0.6] };

// Point de vue de la caméra et position du repère pour chaque objet
export const REGISTRY = {
  about: { icon: User, focus: { pos: [2.7, 2.3, 1.4], target: [0.4, 1.0, -2.0] }, hotspot: [0, 2.0, 0] },
  films: { icon: Film, focus: { pos: [3.3, 2.5, -0.3], target: [1.4, 1.3, -3.3] }, hotspot: [0, 0.95, 0] },
  photos: { icon: Camera, focus: { pos: [2.0, 2.2, -0.9], target: [0.75, 1.15, -2.95] }, hotspot: [0, 0.5, 0] },
  experience: { icon: Clapperboard, focus: { pos: [0.9, 2.3, -0.9], target: [-0.1, 1.2, -3.2] }, hotspot: [0, 0.75, 0] },
  education: { icon: GraduationCap, focus: { pos: [-1.3, 3.0, -0.3], target: [-2.4, 2.9, -3.9] }, hotspot: [0, 0.6, 0.1] },
  skills: { icon: BookOpen, focus: { pos: [0.3, 2.3, 2.9], target: [-3.6, 1.4, 2.3] }, hotspot: [0, 3.0, 0] },
  languages: { icon: Globe2, focus: { pos: [-0.9, 2.4, -0.7], target: [-3.1, 1.3, -3.1] }, hotspot: [0, 2.0, 0] },
  art: { icon: Palette, focus: { pos: [2.6, 3.1, 0.6], target: [2.2, 3.0, -3.9] }, hotspot: [0, 0.8, 0.1] },
  music: { icon: Disc3, focus: { pos: [-0.8, 2.3, 0.6], target: [-3.5, 1.0, -0.6] }, hotspot: [0.45, 0.7, 0] },
  sports: { icon: Dumbbell, focus: { pos: [3.7, 2.0, 4.6], target: [1.9, 0.2, 2.4] }, hotspot: [0, 0.75, 0] },
  associative: { icon: HeartHandshake, focus: { pos: [-1.1, 2.5, -0.9], target: [-2.2, 2.2, -3.8] }, hotspot: [0, 0.6, 0] },
  contact: { icon: Phone, focus: { pos: [4.9, 2.1, 1.0], target: [3.2, 0.8, -1.4] }, hotspot: [0, 1.15, 0] },
  credits: { icon: Projector, focus: { pos: [0.4, 2.5, 6.9], target: [-1.1, 0.8, 3.5] }, hotspot: [0, 1.35, 0] },
};

export const ORDER = Object.keys(REGISTRY);

const add = (a, b) => a.map((v, i) => v + b[i]);

// Point de vue, repère et icône pour n'importe quelle rubrique (prédéfinie ou ajoutée)
export const viewFor = (s) => {
  if (REGISTRY[s?.id]) return REGISTRY[s.id];
  const slot = SLOTS[(Number(s?.slot) || 0) % SLOTS.length];
  const target = add(slot, [0, 0.75, 0]);
  return { icon: MODELS[s?.model]?.icon || MODELS.notebook.icon, focus: { pos: add(target, [2.2, 1.5, 2.4]), target }, hotspot: [0, 1.55, 0], slot };
};
